import { Amplify } from 'aws-amplify';

// Get environment variables
const isDev = import.meta.env.VITE_ENV_DEV_MODE === 'True';

// Amplify configuration
// These values will be set after AWS Cognito deployment
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || '',

      // OAuth configuration for social login
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_AWS_COGNITO_DOMAIN || '',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [
            isDev ? 'http://localhost:5173/' : import.meta.env.VITE_APP_URL || 'https://yourdomain.com/'
          ],
          redirectSignOut: [
            isDev ? 'http://localhost:5173/' : import.meta.env.VITE_APP_URL || 'https://yourdomain.com/'
          ],
          responseType: 'code' as const,
        }
      }
    }
  }
};

// Initialize Amplify
export function configureAmplify() {
  Amplify.configure(amplifyConfig);
}

export default amplifyConfig;
